import { Panel, TableRow } from "@/components";
import { DEFAULT_DATE_FORMAT, NO_VALUE } from "@/constants";
import { UsersA, UsersB } from "@/pages/requests/components/users/components";
import { format } from "date-fns";
import { isValid } from "date-fns/isValid";
import { FC } from "react";
import styles from "./styles.scss";
import { VisitDetailsSummaryProps } from "./types";
import { Person, selectRequestFormStore, useBoundStore } from "@/services";
import { size } from "lodash";
import { isMockEnabled } from "@/pages/requests/components/users/__mock__/utils";

export const VisitDetailsSummary: FC<{
  data?: VisitDetailsSummaryProps;
  inboxWorkersData?: Person[];
  isReview?: boolean;
}> = ({ data, isReview, inboxWorkersData }) => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  const workersData = requestFormData?.Personnels || inboxWorkersData;

  const hasPersonnelsStep = isMockEnabled()
    ? true
    : size(workersData) || size(workersData) > 0;

  return (
    <Panel header="Visit Details">
      <TableRow
        label="Purpose of visit"
        value={data?.Purpose_OF_Visit_E ?? NO_VALUE}
        divided
      />
      <TableRow
        label="From"
        value={
          (data?.Start_date && isValid(new Date(data?.Start_date))
            ? format(new Date(data?.Start_date), DEFAULT_DATE_FORMAT)
            : null) ?? NO_VALUE
        }
      />
      <TableRow
        label="To"
        value={
          (data?.End_Date && isValid(new Date(data?.End_Date))
            ? format(new Date(data?.End_Date), DEFAULT_DATE_FORMAT)
            : null) ?? NO_VALUE
        }
        divided
      />
      <TableRow
        label="Number of personnel"
        value={
          hasPersonnelsStep
            ? size(requestFormData?.Personnels) || workersData?.length
            : data?.Number_Of_Persons ?? NO_VALUE
        }
      />

      {!!hasPersonnelsStep && (
        <>
          {isReview ? (
            <UsersB className={styles.tableWrapReview} withoutNotices />
          ) : (
            <UsersA isInbox inboxData={workersData} />
          )}
        </>
      )}

      <TableRow
        label="Number of vehicles"
        value={data?.Number_Of_Vehicles ?? NO_VALUE}
      />
      <TableRow
        label="Photography Permits"
        value={data?.Number_Of_Camera ?? NO_VALUE}
      />
      <TableRow
        label="Number of vessels"
        value={data?.Number_Of_Vessles ?? NO_VALUE}
      />
    </Panel>
  );
};
